"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ReferencesListController = /*#__PURE__*/function (_PageController) {
  _inherits(ReferencesListController, _PageController);

  var _super = _createSuper(ReferencesListController);

  function ReferencesListController() {
    var _this2;

    _classCallCheck(this, ReferencesListController);

    _this2 = _super.call(this);

    var _this = _assertThisInitialized(_this2); // INIT DATATABLES


    _this2.configDataTable = {
      "pageLength": 20,
      "autoWidth": false,
      "ordering": false
    };
    $("#paymentsTable").on('page.dt', function () {
      _this.clickToChangeTablePage(this);
    }).DataTable(_this2.configDataTable);
    $("#invoicesTable").on('page.dt', function () {
      _this.clickToChangeTablePage(this);
    }).DataTable(_this2.configDataTable);
    return _this2;
  }

  _createClass(ReferencesListController, [{
    key: "clickToChangeTablePage",
    value: function clickToChangeTablePage(button) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(button).parents(".tableWrapper").offset().top - 50
      }, 600);
    }
  }]);

  return ReferencesListController;
}(PageController);

function deleteReference(el) {
  var link = $(el).attr("data-link");
  var name = $(el).attr("data-name");

  if (confirm('Do you really want delete reference: ' + name)) {
    $.nette.ajax({
      url: link,
      type: 'GET'
    });
  }
}